import { Box, Typography, Avatar, SvgIcon } from '@mui/material'
import PropTypes from 'prop-types'

import { useKBar } from 'kbar'
import SearchIcon from '@hapana/shared/web/styles/assets/svgs/search.svg'
import IconAssistant from '@hapana/shared/web/styles/assets/svgs/hapana-ai-icon.svg'

import { useCorporateWithStore } from '_stores/corporate.store'
import { useSiteNavigation } from '_hooks/use-site-navigation'
import Loading from '@hapana/shared/web/components/shared/loading/loading.component'

import { styles } from './navigation-header.styles'

const NavigationHeader = ({ isOpen = false }) => {
  const { brandName, logoUrl, loadingCorporateByPrefix } = useCorporateWithStore()
  const { query } = useKBar()
  const { navigateToSite, navigateToCorporate, siteId } = useSiteNavigation()

  const handleOpenKBar = () => {
    query.toggle()
  }

  const handleAssistantClick = () => {
    if (siteId) {
      navigateToSite('/assistant')
    } else {
      navigateToCorporate('/assistant')
    }
  }

  if (loadingCorporateByPrefix) {
    return <Loading />
  }

  return (
    <Box sx={styles.headerContainer}>
      <Box sx={styles.companyButton}>
        {logoUrl ? (
          <Avatar src={logoUrl} alt={`${brandName}`} sx={styles.companyIcon} />
        ) : (
          <Avatar sx={{ ...styles.companyIcon, ...styles.companyIconPlaceholder }}>
            {brandName?.trim()?.charAt(0)?.toUpperCase() || '?'}
          </Avatar>
        )}
        {isOpen && <Typography sx={styles.companyName}>{brandName}</Typography>}
      </Box>

      {/* Assistant Button — hidden for now (Monday lift-the-bar); keep code. */}
      {/* eslint-disable-next-line no-constant-binary-expression -- OC-1030: deliberately parked UI; the note above says keep it until it ships */}
      {false && (
        <Box sx={styles.locationButton} onClick={handleAssistantClick}>
          <Box sx={styles.locationIconContainer}>
            <SvgIcon component={IconAssistant} sx={styles.locationIcon} />
          </Box>
          {isOpen && (
            <Typography sx={styles.locationText} variant="header4">
              Assistant
            </Typography>
          )}
        </Box>
      )}

      {/* KBar Search Button */}
      <Box
        sx={styles.locationButton}
        onClick={handleOpenKBar}
        data-testid="navigation-header-quick-search"
      >
        <Box sx={styles.locationIconContainer}>
          <SvgIcon component={SearchIcon} sx={styles.locationIcon} />
        </Box>
        {isOpen && (
          <Typography sx={styles.locationText} variant="header4">
            Quick search
          </Typography>
        )}
      </Box>
    </Box>
  )
}

NavigationHeader.propTypes = {
  isOpen: PropTypes.bool,
}

NavigationHeader.defaultProps = {
  isOpen: false,
}

export default NavigationHeader
